import axios from 'axios';
import normalize from 'Utils/normalizer';
import { omitBy, isEmpty, isNil } from 'lodash';
import { errorHandler } from '../utils';
import { getAccessToken, apiURL } from '../helpers';

export interface FetchPaymentObjectPayload {
  // paymentID?: string | null,
  orderIDs: string[] | null
  shipName: string
  email: string
  phone: string
  ord_customfield1?: string
  ord_customfield2?: string
  ord_customfield3?: string
  appliedPlatformVouchers?: any[] | null
  revpay_payment_code?: number // required for revpay
  paymentBetween: string;
}

export interface CreateRePaymentObjectPayload {
  paymentID: string,
  orderIDs: string[] | null
  shipName: string
  email: string
  phone: string
  ord_customfield1?: string
  ord_customfield2?: string
  ord_customfield3?: string
  appliedPlatformVouchers?: any[] | null
  revpay_payment_code?: number // required for revpay
  paymentBetween: string;
}

export interface FetchPaymentObjectResponse {
  payload: { [x: string]: any },
  paymentID: string
}

export interface ObjectErrorStack {
  error: {
    message: any,
    value?: any,
    code?: any,
    stack?: any
  }
}

export const fetchPaymentObject = async (payload: FetchPaymentObjectPayload) => {
  const url = apiURL('/ecom/payment/object/create');
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ ...payload, type: process.env.GATEWAY_TYPE }, isNil),
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });

    return response.data;
  }
  catch(err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPaymentObject(payload);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}

export const createRePaymentObject = async (payload: CreateRePaymentObjectPayload) => {
  const url = apiURL('/ecom/payment/repayment/update');
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ ...payload, type: process.env.GATEWAY_TYPE }, isNil),
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });

    return response.data;
  }
  catch(err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await createRePaymentObject(payload);
      const { value, code, message, stack, info } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack, info }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}

interface FetchPaymentStatusPayload {
  paymentID: string
}

export const fetchPaymentStatus = async (payload: FetchPaymentStatusPayload) => {
  const url = apiURL('/ecom/payment/status/fetch');

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ ...payload, type: process.env.GATEWAY_TYPE }, isNil),
    });

    return normalize.response.payment(response.data);
  }
  catch(err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPaymentStatus(payload);
      const { value, code, message, stack } = await errorHandler.response(error, { callback, noRedirect: true });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}
